import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils/tailwind.util';
const AI_BUILDER_ASSISTANT_MESSAGE_SLOT_BASE_CLASS_NAME = 'flex w-full';
type AiBuilderAssistantMessageSlotVariant = 'progress' | 'body' | 'jumpLinks' | 'action';
const AI_BUILDER_ASSISTANT_MESSAGE_SLOT_VARIANT_CLASS_NAME: Record<AiBuilderAssistantMessageSlotVariant, string> = {
  progress: 'py-none',
  body: 'items-start px-sm py-3xs',
  jumpLinks: 'max-w-[360px] flex-col items-start gap-sm px-sm py-none',
  action: 'items-start gap-none px-3xs'
};
export const AiBuilderAssistantMessageSlot = ({
  className,
  variant,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  variant: AiBuilderAssistantMessageSlotVariant;
}) => {
  return <div className={cn(AI_BUILDER_ASSISTANT_MESSAGE_SLOT_BASE_CLASS_NAME, AI_BUILDER_ASSISTANT_MESSAGE_SLOT_VARIANT_CLASS_NAME[variant], className)} {...props} data-sentry-component="AiBuilderAssistantMessageSlot" data-sentry-source-file="AiBuilderAssistantMessageSlot.tsx" />;
};